module.exports = __webpack_public_path__ + "static/media/HTML5_logo_and_wordmark.525f317f.svg";